export default __webpack_public_path__ + "static/media/about.064f2a44.svg";